@import 'styles/mixins';
@import 'styles/variables';

.title {
  @include xl-semibold;
  margin-bottom: 24px;

  @include for-phone-only {
    text-align: center;
  }
}

.description {
  color: var(--neutral-40);
  @include md-regular;
  margin-right: 32px;
  margin-bottom: 12px;

  @include for-phone-only {
    text-align: justify;
    margin: 0 0 24px 0;
  }
}
